"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _router = _interopRequireDefault(require("@/router"));

var _store = _interopRequireDefault(require("@/store"));

var _auth = require("@/utils/auth");

var _helpes = require("@/utils/helpes");

var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));

// get token from cookie
// get token from cookie
_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, loginUrl, hasGetUserInfo, user;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // 设置页面标题
            document.title = (0, _getPageTitle.default)(to.meta.title);
            hasToken = (0, _auth.getToken)();
            loginUrl = (0, _helpes.getLoginUrl)(to.fullPath);

            if (!hasToken) {
              _context.next = 29;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 8;
              break;
            }

            // 已经登录，跳转到首页
            next({
              path: '/'
            });
            _context.next = 27;
            break;

          case 8:
            // 获取用户信息
            hasGetUserInfo = _store.default.getters.user && _store.default.getters.user.id;

            if (!hasGetUserInfo) {
              _context.next = 13;
              break;
            }

            next();
            _context.next = 27;
            break;

          case 13:
            _context.prev = 13;
            console.log("store.dispatch('user/getInfo')"); // get user info

            _context.next = 17;
            return _store.default.dispatch('user/getInfo');

          case 17:
            user = _context.sent;

            if (!user) {
              console.log('to11111');
              console.log(to); // 清除用户信息，退出登录，跳转登录页

              _store.default.commit('user/LOGOUT');
            } else {
              next();
            }

            _context.next = 27;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](13);

            // 清除用户信息，退出登录，跳转登录页
            _store.default.commit('user/LOGOUT'); // Notify.error(error || 'Has Error')
            // next(`/login?redirect=${to.path}`)


            console.log('to22222');
            console.log(to);
            next(loginUrl);

          case 27:
            _context.next = 30;
            break;

          case 29:
            /* has no token */
            if (to.meta.auth) {
              console.log('to33333');
              console.log(to); // other pages that do not have permission to access are redirected to the login page.

              next(loginUrl);
            } else {
              next();
            }

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[13, 21]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());